export default {
    setCart (state,  originCart) {
        state.originCart = originCart
        state.products =  originCart.products
    },
    setInitCart(state , isInit){
        state.init = isInit;
    }
}